// extracted by mini-css-extract-plugin
export default {"container":"StaffSelectPageTools_container__m2VlU","buttonWrapper":"StaffSelectPageTools_buttonWrapper__tp9fU"};